import type { microCMSDraftKeyQuery } from '@/wabunka-src/common/models/microCMS';

import type { RouteLocationNormalizedLoaded } from 'vue-router';

export const useMicroCMSParams = (route: RouteLocationNormalizedLoaded) => {
  const contentId = route.params.id as string;

  const draftKey: string = route.query.draftKey as string;

  // draftKeyがある場合のみオブジェクトを返す
  const draftKeyQuery: microCMSDraftKeyQuery = { draftKey: draftKey ? draftKey : undefined };

  /** プレビュー経由かどうか。値が空（`?draftKey=`）でもプレビューとして扱う */
  const hasDraftKey = route.query.draftKey !== undefined;

  return {
    contentId,
    draftKey,
    draftKeyQuery,
    hasDraftKey,
  };
};
